// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"0a2016ed","893":"2195d8f8","976":"623583a8"}[chunkId] + ".chunk.js";
};